<!-- eslint-disable max-len -->
<route>
  {
    "meta": {
      "requireAdmin": true,
      "customSite": true
    }
  }
</route>
<template>
  <div class="py-1">
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="segmentPopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full z-50"
        style="background-color: #00000099"
      >
        <div
          class="bg-white rounded-lg w-3/4 lg:w-1/2 xl:w-144 max-h-95/100 overflow-y-scroll"
        >
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-3xl">
                Create new {{ pagetitle }}
              </div>
            </div>
            <hr class="w-full my-3" />
            <div class="form-control w-full">
              <input
                ref="name"
                type="text"
                placeholder="Title"
                class="input input-bordered w-full mb-2 mt-2"
                required
                name="title"
                v-model="title"
              />
            </div>
            <div class="flex justify-between w-full items-center">
              <label
                class="cursor-pointer label mt-2 justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="fromQuery"
                />
                <span class="label-text text-lg ml-3">From Query</span>
              </label>
              <div class="flex items-center font-semibold">
                Members : {{ previewStudentList.length }}
              </div>
            </div>
            <section v-if="fromQuery" class="mt-0 w-full">
              <div
                class="w-full"
                v-for="(filterDetails, mainIndex) in filterList"
                :key="mainIndex"
              >
                <!-- filter group -->
                <section
                  class="w-full border border-gray-500 p-2 rounded-md mt-4"
                >
                  <!-- filter filter -->
                  <div class="w-full">
                    <!-- filter header start -->
                    <div class="label-text text-lg ml-3 flex justify-between">
                      <div>
                        Matching
                        <select
                          class="select select-bordered text-base mx-1"
                          v-model="filterDetails.matching"
                          @change="handleChangeMatching($event, mainIndex)"
                        >
                          <option disabled="disabled" value="">Select</option>
                          <option
                            v-for="(data, index) in Object.values(
                              filterConstantInside,
                            )"
                            :key="index"
                            :value="data"
                          >
                            {{ data }}
                          </option>
                        </select>
                        of the following
                      </div>
                      <div @click="handleRemoveGroup(mainIndex)">
                        <closeIcon />
                      </div>
                    </div>
                    <!-- filter header end -->
                    <div
                      v-for="(subFilter, subIndex) in filterDetails.filter"
                      :key="subIndex"
                    >
                      <div class="w-full mb-0">
                        <!-- filter matching start  -->
                        <p v-if="subIndex !== 0" class="text-center mb-0">
                          {{
                            filterDetails.matching === filterConstantInside.ALL
                              ? 'and'
                              : 'or'
                          }}
                        </p>
                        <!-- filter matching end  -->
                        <section
                          :class="[
                            'flex items-center w-full flex-wrap',
                            subIndex ? 'mt-2' : 'mt-5',
                          ]"
                        >
                          <section
                            v-if="fromQuery"
                            class="flex items-center flex-wrap"
                          >
                            <!-- // options start  -->
                            <select
                              class="select select-bordered flex-1 mr-2 min-w-max"
                              required
                              v-model="subFilter.filterType"
                              @change="
                                handleChangeFiltertype(
                                  $event,
                                  subIndex,
                                  mainIndex,
                                )
                              "
                            >
                              <option disabled="disabled" value="">
                                Select...
                              </option>
                              <option :value="enrollFilterType.ENGAGED_IN">
                                Engaged
                              </option>
                              <option :value="enrollFilterType.COMMENTED_IN">
                                Commented
                              </option>
                              <option :value="enrollFilterType.IN_SEGMENT">
                                In segment
                              </option>
                              <option
                                :value="enrollFilterType.YOU_MESSAGED_THEM"
                              >
                                You messaged them
                              </option>
                              <option
                                :value="enrollFilterType.THEY_MESSAGED_YOU"
                              >
                                They messaged you
                              </option>
                              <option
                                :value="enrollFilterType.HAS_FOLLOWER_COUNT"
                              >
                                Has follower count
                              </option>
                              <option
                                v-if="userInfo.role==='SUPERADMIN'"
                                :value="enrollFilterType.CAN_SEND_DM_QUERY"
                              >
                                Can send DM
                              </option>
                              <option :value="enrollFilterType.TWITTER_LIST">
                                Twitter List

                              </option>
                            </select>
                            <!-- // options end  -->
                            <!-- twiter list input  -->
                            <div  v-if="
                                (fromQuery &&
                                  subFilter.filterType ===
                                    enrollFilterType.TWITTER_LIST)
                              ">
                              <input
                                type="text"
                                style="max-width: 220px"
                                placeholder="Twitter list Id"
                                class="input input-bordered h-8"
                                required
                                name="twitterListId"
                                 v-model="subFilter.twitterListId"
                                @change="
                                  handleChangeTwitterListId($event, subIndex, mainIndex)
                                "
                              />
                            </div>
                            <!-- twiter list input  -->
                            <!-- engaged, commented, and messaged type start  -->
                            <!-- Times start -->
                            <div
                              class="ml-2 flex items-center times_div"
                              v-if="
                                (fromQuery &&
                                  subFilter.filterType ===
                                    enrollFilterType.ENGAGED_IN) ||
                                subFilter.filterType ===
                                  enrollFilterType.COMMENTED_IN ||
                                subFilter.filterType ===
                                  enrollFilterType.YOU_MESSAGED_THEM ||
                                subFilter.filterType ===
                                  enrollFilterType.THEY_MESSAGED_YOU
                              "
                            >
                              <input
                                type="number"
                                style="max-width: 80px"
                                placeholder="Engaged"
                                class="input input-bordered h-8"
                                required
                                name="engagedTimes"
                                v-model="subFilter.times"
                                @change="
                                  handleChangeTimes($event, subIndex, mainIndex)
                                "
                              />
                              <h5
                                class="mb-0 ml-2 text-sm font-semibold whitespace-no-wrap"
                              >
                                <!-- {{ subFilter.times == 1 ? 'Time in' : ' Times in' }}: -->
                                Time(s) in
                              </h5>
                            </div>
                            <!-- Times end -->
                            <!-- Duration -->
                            <div
                              class="mt-5 sm:mt-0 sm:ml-5"
                              style="max-width: 200px"
                            >
                              <select
                                class="select select-bordered flex-1 w-full"
                                required
                                v-model="subFilter.filterDuration"
                                v-if="
                                  (fromQuery &&
                                    subFilter.filterType ===
                                      enrollFilterType.ENGAGED_IN) ||
                                  subFilter.filterType ===
                                    enrollFilterType.COMMENTED_IN ||
                                  subFilter.filterType ===
                                    enrollFilterType.YOU_MESSAGED_THEM ||
                                  subFilter.filterType ===
                                    enrollFilterType.THEY_MESSAGED_YOU
                                "
                                @change="
                                  handleChangeFilterDuration(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              >
                                <option disabled="disabled" value="">
                                  Select...
                                </option>
                                <option value="1">Last Day</option>
                                <option value="7">Last week</option>
                                <option value="14">2 weeks</option>
                                <option value="30">Last month</option>
                                <option value="90">3 Month</option>
                              </select>
                            </div>
                            <!-- engaged, commented, and messaged type end  -->
                            <!-- has followers type start  -->
                            <!-- option for operators start -->
                            <div
                              class="mt-5 sm:mt-0 sm:ml-5 lg:ml-0"
                              style="max-width: 200px"
                            >
                              <select
                                class="select select-bordered flex-1 w-full"
                                required
                                v-model="subFilter.filterOperator"
                                v-if="
                                  fromQuery &&
                                  subFilter.filterType ===
                                    enrollFilterType.HAS_FOLLOWER_COUNT
                                "
                                @change="
                                  handleChangeFilterOprator(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              >
                                <option disabled="disabled" value="">
                                  Select...
                                </option>
                                <option :value="operator.LESS_THAN">
                                  Less than
                                </option>
                                <option :value="operator.EQUALT_TO">
                                  Equal to
                                </option>
                                <option :value="operator.MORE_THAN">
                                  More than
                                </option>
                              </select>
                            </div>
                            <!-- Times start -->
                            <div
                              class="ml-2 flex items-center times_div"
                              v-if="
                                fromQuery &&
                                subFilter.filterType ===
                                  enrollFilterType.HAS_FOLLOWER_COUNT
                              "
                            >
                              <input
                                type="number"
                                style="max-width: 100px"
                                placeholder="Engaged"
                                class="input input-bordered h-8"
                                required
                                name="engagedTimes"
                                v-model="subFilter.followers"
                                @change="
                                  handleChangeFollowers(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              />
                            </div>
                            <!-- Times end -->
                            <!-- option for operators start -->
                          </section>

                          <!-- segmeny list  -->
                          <select
                            v-if="
                              fromQuery &&
                              subFilter.filterType ===
                                enrollFilterType.IN_SEGMENT &&
                              subFilter.filterType !== ''
                            "
                            class="select select-bordered flex-1 mr-10 mt-5 sm:mt-0"
                            style="max-width: 200px"
                            required
                            @change="
                              handleChangeSegment($event, subIndex, mainIndex)
                            "
                            v-model="filterDetails.filter[subIndex].segment"
                          >
                            <option disabled="disabled" value="">
                              Select Segment
                            </option>
                            <option
                              v-for="(item, index) in segmentOnly"
                              :value="item._id"
                              :key="index"
                            >
                              {{ item.title.slice(0, 30)
                              }}{{ item.title.length > 30 ? '...' : '' }}
                            </option>
                          </select>
                          <div
                            class="ml-auto"
                            @click="handleRemoveFilter(subIndex, mainIndex)"
                          >
                            <closeIcon />
                          </div>
                        </section>
                      </div>
                    </div>

                    <button
                      :class="['mt-5 btn btn-primary w-full']"
                      @click="handleAddFilter(mainIndex)"
                    >
                      Add Filter
                    </button>
                  </div>
                </section>
              </div>
              <button
                class="btn btn-outline w-full mt-5"
                @click="handleAddGroup"
              >
                Add Filter Group
              </button>
            </section>
            <div v-if="fromQuery && role !== 'USER'">
              <label
                class="cursor-pointer label mt-2 justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="isDynamicSegment"
                />
                <span class="label-text text-lg ml-3">Make List Dynamic</span>
              </label>
            </div>

            <hr class="w-full my-3" />
            <section v-if="errorMessage" class="mb-5 w-full">
              <ErrorAlert :error="errorMessage" />
            </section>
            <section class="w-full flex justify-center">
              <div class="mr-5">
                <button class="btn btn-primary btn-outline" @click="callback()">
                  cancel
                </button>
              </div>
              <div class="">
                <button
                  :disabled="title.trim() === ''"
                  class="btn btn-primary"
                  @click="
                    fromQuery ? handleConfirmSubmission() : createCourse()
                  "
                >
                  Create
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import adminAPI from '@/services/admin';
import moment from 'moment';
import courseAPI from '@/services/course';
import store from '@/store';
import closeIcon from '../icons/closeIcon.vue';
import ErrorAlert from '../Common/ErrorAlert.vue';
import utils from '@/services/utils';
import enrollFilterType from '@/utils/Constants/enrollFilterType.contstants';
import operator from '@/utils/Constants/operator.constants';

const filterConstant = {
  ANY: 'Any',
  ALL: 'All',
  NONE: 'None',
};

export default {
  name: 'SegmentModal',
  layout: 'admin',
  store,
  props: ['segmentPopup', 'callback', 'fetchCourseAgain', 'segmentOnly'],
  components: { closeIcon, ErrorAlert },
  data() {
    return {
      tempSelect: '',
      fromQuery: false,
      title: '',
      Type: 'segment',
      pagetitle: 'List',
      courseType: 'segment',
      hasSubmitted: false,
      userId: '',
      description: '',
      Deliver: 'TWEET',
      price: '',
      maxStudents: '',
      linear: false,
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      Limitstudent: false,
      frequency: '',
      Frequency: false,
      publish: true,
      sharingtips: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      Enablehashtag: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      Threadseries: false,
      image: '',
      imagePreview:
        'https://res.cloudinary.com/implicit/image/upload/v1643873624/courses/defaultimage_gtfecl.jpg',
      img: 'defaultimage_gtfecl.jpg',
      filterConstantInside: filterConstant,
      filterList: [
        {
          matching: filterConstant.ANY,
          filter: [],
        },
      ],
      errorMessage: '',
      openPreviewPop: false,
      previewStudentList: [],
      isConfirm: false,
      selectOption: '',
      engagedTimes: 1,
      selectDuration: '',
      enrollFilterType,
      isDynamicSegment: false,
      role: 'USER',
      operator,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
    userInfo() {
      return this.$store.state.userDetails;
    },
  },
  watch: {
    segmentPopup(val) {
      if (val) {
        this.focusInput();
      }
    },
    userInfo(val) {
      this.userId = val?.userId;
      return val;
    },
  },
  async mounted() {
    store.commit('toggleLoading', true);
    this.userId = this.userInfo?.userId;
    if (this.$route.query.userId) {
      this.userId = this.$route.query.userId;
    }
    this.role = this.userInfo?.role;
    store.commit('toggleLoading', false);
  },
  methods: {
    async createCourse() {
      try {
        this.hasSubmitted = true;
        if (this.title.length > 5) {
          store.commit('toggleLoading', true);
          const response = await this.$store.dispatch('createCourse', {
            title: this.title,
            userId: this.userId,
          });
          console.log(response);
          this.callback();
          this.$store.dispatch('fetchCoursesList', this.userId);
          await this.$store.dispatch('fetchCoursesListWithDetails', {
            userId: this.userId,
          });
          this.title = '';
          this.fetchCourseAgain();
          store.commit('toggleLoading', false);
          utils.setStatusMsg(this, 'New list created');
        }
      } catch (error) {
        store.commit('toggleLoading', false);
        console.log({ error });
      }
    },
    checkValidation() {
      let errors = '';
      if (!this.title) {
        errors = 'Please enter valid Title';
      }
      if (!this.filterList.length) {
        errors = 'Please add atlease 1 group';
      }
      // this.filterList.forEach((data) => {
      //   if (data.filter.includes('')) {
      //     errors = 'Please either select a Segment or remove';
      //   }
      //   if (!data.segments.length) {
      //     errors = 'Please add atleast 1 segment or remove group';
      //   }
      // });
      this.errorMessage = errors;
      this.createfromQuery();
    },
    handleConfirmSubmission() {
      this.isConfirm = true;
      this.checkValidation();
    },
    async createfromQuery() {
      try {
        if (!this.errorMessage) {
          if (this.isConfirm) {
            this.callback();
            store.commit('toggleLoading', true);
          }
          const publishDateTime = new Date(this.publishDateTime);
          const payload = {
            title: this.title,
            userId: this.userId,
            type: this.Type,
            publishDateTime: this.scheduled
              ? publishDateTime.getTime()
              : moment().subtract(30, 'days').toDate(),
            description: this.description,
            price: this.price === '' ? 0 : this.price,
            maxStudents: this.maxStudents,
            linear: this.linear,
            scheduled: this.scheduled,
            Frequency: this.Frequency,
            frequency: this.Frequency ? this.frequency : '',
            publish: this.publish,
            currency: 'USD',
            purchaseParityEnabled: this.PPP,
            medium: this.Deliver,
            setStudentLimit: this.Limitstudent,
            sharingtips: this.sharingtips,
            Enablehashtag: this.Enablehashtag,
            Threadseries: this.Threadseries,
            showBackground: this.showBackground,
            showCheck: this.showCheck,
            showFeedback: this.showFeedback,
            showParticipate: this.showParticipate,
            showTakeaway: this.showTakeaway,
            AllowsubmissionviaDM: this.AllowsubmissionviaDM,
            fromQuery: true,
            isDynamicSegment: this.isDynamicSegment,
            filterList: this.filterList,
            isConfirm: this.isConfirm,
          };
          const response = await courseAPI.createCourse(payload);
          if (!this.isConfirm) {
            this.previewStudentList = response || [];
          } else {
            this.fetchCourseAgain();
            this.title = '';
            this.filterList = [];
            this.previewStudentList = [];

            this.isConfirm = false;
            store.commit('toggleLoading', false);
            if (this.fromQuery) {
              utils.setStatusMsg(this, 'New dynamic list created');
            } else {
              utils.setStatusMsg(this, 'New list created');
            }
            this.fromQuery = false;
          }
        }
      } catch (error) {
        store.commit('toggleLoading', false);
        this.isConfirm = false;
        console.log({ error });
        utils.setStatusMsg(this, error?.response?.data?.message);
        this.previewStudentList = [];
      }
    },
    handleAddGroup() {
      this.filterList.push({
        matching: filterConstant.ANY,
        filter: [
          {
            filterType: '',
            filterDuration: '',
            times: 1,
            segment: '',
            filterOperator: '',
            followers: 1000,
            canSendDMQuery: false,
            twitterListId: '',
          },
        ],
      });
    },
    handleRemoveGroup(index) {
      this.createfromQuery();
      this.filterList.splice(index, 1);
    },
    handleAddFilter(index) {
      // console.log(this.filterList, index);
      this.filterList[index].filter.push({
        filterType: '',
        filterDuration: '',
        times: 1,
        segment: '',
        filterOperator: '',
        followers: 1000,
        canSendDMQuery: false,
        twitterListId: 0,
      });
    },
    handleRemoveFilter(index, mainIndex) {
      this.filterList[mainIndex].filter.splice(index, 1);
      this.createfromQuery();
    },
    handleChangeMatching(e, index) {
      this.filterList[index].matching = e.target.value;
      this.createfromQuery();
    },
    handleChangeSegment(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].segment = e.target.value;
      this.createfromQuery();
    },
    handleChangeFiltertype(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterType = e.target.value;
      if (enrollFilterType.YOU_MESSAGED_THEM === e.target.value) {
        this.filterList[mainIndex].filter[subIndex].filterDuration = '7';
      } else {
        this.filterList[mainIndex].filter[subIndex].filterDuration = '';
      }
      console.log(
        'working and calling',
        this.filterList[mainIndex]?.filter[subIndex],
      );
      this.filterList[mainIndex].filter[subIndex].canSendDMQuery =
        enrollFilterType.CAN_SEND_DM_QUERY === e.target.value;
      this.createfromQuery();
    },
    handleChangeFilterDuration(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterDuration =
        e.target.value;
      this.createfromQuery();
    },
    handleChangeFilterOprator(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterOperator =
        e.target.value;
      this.createfromQuery();
    },
    handleChangeTimes(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].times = e.target.value;
      this.createfromQuery();
    },
    handleChangeFollowers(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].followers = e.target.value;
      this.createfromQuery();
    },
    handleChangeTwitterListId(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].twitterListId =
        e.target.value;
      this.createfromQuery();
    },
    handleClosePreviewPopup() {
      this.openPreviewPop = !this.openPreviewPop;
      this.createfromQuery();
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.name.focus();
      });
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
.select {
  font-weight: 550;
  height: 2.2rem;
  min-height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 2rem;
}
@media (max-width: 440px) {
  .times_div {
    margin-top: 10px;
  }
}
</style>
